import { lazy } from "react";
import { Outlet, Route } from "react-router-dom";
import { PropertyReport } from "src/apps/BrokerDashboard/pages/Marketing/PropertyReport";
import BdmBrokerageSearch from "src/embeds/BdmBrokerageSearch";
import BdmCalendar from "src/embeds/BdmCalendar";
import BdmFinder from "src/embeds/BdmFinder";
import { IframeIOProvider } from "src/iframe";
import { lazyImport } from "src/lib";

const CostEstimateEmbed = lazy(() => lazyImport(() => import("src/embeds/CostEstimate")));
const CookieTrackerEmbed = lazy(() => lazyImport(() => import("src/embeds/CookieTracker")));
const ClassifierEmbed = lazy(() => lazyImport(() => import("src/embeds/Classifier")));
const DocumentApprovalToolEmbed = lazy(() => lazyImport(() => import("src/embeds/DocumentApprovalTool")));
const PostalCodeCheckerEmbed = lazy(() => lazyImport(() => import("src/embeds/PostalCodeChecker")));
const CostCalculator = lazy(() => lazyImport(() => import("src/embeds/CostCalculator")));
const RateCalculator = lazy(() => lazyImport(() => import("src/embeds/RateCalculator")));
const ApprovedAppraisers = lazy(() => lazyImport(() => import("src/embeds/ApprovedAppraisers")));
const RecommendedAppraisers = lazy(() => lazyImport(() => import("src/embeds/RecommendedAppraisers")));

const IframeIOLayout = () => (
  <IframeIOProvider>
    <Outlet />
  </IframeIOProvider>
);

export function EmbedRoutes() {
  return [
    <Route key="iframelayout" element={<IframeIOLayout />}>
      <Route path="/embed/classifier" element={<ClassifierEmbed />} />
      <Route path="/embed/document-approval" element={<DocumentApprovalToolEmbed />} />
      <Route path="/embed/postal-checker" element={<PostalCodeCheckerEmbed />} />
      <Route path="/embed/bdm-finder" element={<BdmFinder />} />
      <Route path="/embed/rate-calculator" element={<RateCalculator />} />
      <Route path="/bdm-calendar" element={<BdmCalendar />} />
      <Route path="embed/bdm-brokerage-search" element={<BdmBrokerageSearch />} />
    </Route>,
    <Route key="cost" path="/embed/cost-estimate" element={<CostEstimateEmbed />} />,
    <Route key="analytics" path="/embed/analytics" element={<CookieTrackerEmbed />} />,
    <Route key="calculator" path="/embed/calculator" element={<CostCalculator />} />,
    <Route key="scenario" path="/embed/scenario-planner" element={<PropertyReport backButton={false} />} />,
    <Route key="appraisers" path="/embed/approved-appraisers" element={<ApprovedAppraisers />} />,
    <Route key="recommended-appraisers" path="/appraisers/:eid" element={<RecommendedAppraisers />} />,
  ];
}
